<template>
  <div class="languages-table">
    <div class="table-toolbar">
      <button
        class="btn btn-primary"
        data-testid="languages-btn-add"
        @click="$emit('add-language')"
      >
        <i class="pi pi-plus"></i>
        {{ t('Adicionar idioma') }}
      </button>
    </div>

    <data-table
      :config="datatableConfig"
      :data="rows"
      :refreshButton="{ show: true }"
      @refresh="$emit('refresh')"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

interface LanguageRow {
  id: string;
  name: string;
  description?: string;
  created_at?: string;
}

defineProps<{
  rows: LanguageRow[];
  loading?: boolean;
}>();

defineEmits<{
  'add-language': [];
  refresh: [];
}>();

const tableColumns = computed(() => [
  { data: 'id', title: t('Código'), filterType: 'text' },
  { data: 'name', title: t('Nome'), filterType: 'text' },
  { data: 'description', title: t('Descrição'), filterType: 'text' },
  { data: 'created_at', title: t('Criado em'), renderType: 'datetime', filterType: 'date' }
]);

const datatableConfig = computed(() => ({
  tableId: 'languagesDataTable',
  columns: tableColumns.value,
  rowTestId: (data: Record<string, unknown>) => {
    const id = data?.id;
    return id == null ? '' : `languages-row-${id}`;
  },
  pagination: true,
  pageLength: 25,
  showFilters: true,
  filterDisplay: 'row'
}));
</script>

<style scoped>
.languages-table {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.table-toolbar {
  display: flex;
  gap: 10px;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-primary {
  background-color: #0066cc;
  color: white;
}

.btn-primary:hover {
  background-color: #0052a3;
}
</style>
